export const roomTypeSelect = [
  {
    display: 'Bedroom',
    value: 'Bedroom'
  },
  {
    display: 'Bathroom',
    value: 'Bathroom'
  },
  {
    display: 'Back Yard',
    value: 'Back Yard'
  },
  {
    display: 'Living Room / Family Room',
    value: 'Living Room'
  },
  {
    display: 'Front Yard',
    value: 'Front Yard'
  },
  {
    display: 'Dining Room',
    value: 'Dining Room'
  },
  {
    display: 'Stairwell',
    value: 'Stairwell'
  },
  {
    display: 'Hallway',
    value: 'Hallway'
  },
  {
    display: 'Kitchen',
    value: 'Kitchen'
  },
  {
    display: 'Garage',
    value: 'Garage'
  },
  {
    display: 'Laundry',
    value: 'Laundry'
  },
  {
    display: 'Office',
    value: 'Office'
  },
  {
    display: 'Patio',
    value: 'Patio'
  }
]
